import { HttpModule } from '@nestjs/axios';
import { Module } from '@nestjs/common';
import { CustomerService } from '../database/services/customer/customer.service';
import { DatabaseService } from '../database/services/database/database.service';
import { LocationService } from '../database/services/location/location.service';
import { ServiceService } from '../database/services/service/service.service';
import { CustomerController } from './controllers/customer/customer.controller';
import { LocationController } from './controllers/location/location.controller';
import { ServiceController } from './controllers/service/service.controller';


@Module({
  imports: [HttpModule],
  controllers: [CustomerController,ServiceController,LocationController],
  providers: [DatabaseService,CustomerService,ServiceService,LocationService],
})
export class ApiModule {}
